import {
  Button,
  Chip,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import InputField from "../FormComponents/InputField";
import SelectingTable from "../FormComponents/SelectingTable";
import {
  getExCategoryDataByFilter,
  getExportProducts,
} from "../services/Export";
import { getCustomers } from "../services/Customer";
import { getWarehouseData } from "../services/Warehouse";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // height: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function WarehouseSelectingPopup({
  setOpenWarehouseTable,
  openWarehouseTable,
  handleCloseWarehouseTable,
  setSelectedWarehouse,
  selectedWarehouse,
  skipList,
  isOneChoise,
}) {
  const [page, setPage] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [warehouseRows, setWarehouseRows] = React.useState([]);
  const [error, setErrors] = React.useState("");

  const [selectedType, setSelectedType] = React.useState("");
  const [warehouseTypes, setWarehouseTypes] = React.useState([]);

  /// filter area /////////////////////////////////

  // filter values
  const [filter, setFilter] = useState({
    _name: "",
    _type: "",
    _isActive: "",
  });

  //reset filters
  const resetFilters = () => {
    setFilter({
      _name: "",
      _type: "",
      _isActive: "",
    });
  };

  //to handle changing filters
  const handleFilterChange = (name, val) => {
    setFilter({
      ...filter,
      [name]: val,
    });
  };

  /////////////////////////////////////////////////

  const handleChangepage = async (event, value) => {
    setPage(value - 1);
  };

  useEffect(async () => {
    await fetchData();
  }, [page, filter]);

  const fetchData = async () => {
    setOpenWarehouseTable(true);

    let result = await getWarehouseData(page, rowsPerPage, filter);
    if (result !== "Something went wrong...") {
      let warehouseSet = result.content;

      //set total rows and pages
      setTotalPages(result.totalPages);

      const newSet = [];
      if (warehouseSet) {
        for (let x = 0; x < warehouseSet.length; x++) {
          //set data in new set list to display in the table
          // check if the warehouse is in the skip list
          if (skipList) {
            if (!skipList.includes(warehouseSet[x].warehouseId)) {
              newSet.push(
                createData(
                  warehouseSet[x].warehouseName,
                  warehouseSet[x].warehouseType,
                  warehouseSet[x].isActive ? "Active" : "Inactive",
                  warehouseSet[x].warehouseId
                )
              );
            }
          } else {
            newSet.push(
              createData(
                warehouseSet[x].warehouseName,
                warehouseSet[x].warehouseType,
                warehouseSet[x].isActive ? "Active" : "Inactive",
                warehouseSet[x].warehouseId
              )
            );
          }
        }
      }

      // set rows to table
      setWarehouseRows(newSet);
    } else {
      setErrors("Something went wrong when Warehouses..");
    }
  };

  const columns = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Name",
    },
    {
      id: "type",
      numeric: false,
      disablePadding: true,
      label: "Type",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
    },
  ];

  function createData(name, type, status, warehouse_id) {
    return {
      name,
      type,
      status,
      warehouse_id,
    };
  }

  const updateWarehouseType = (value) => {
    setSelectedType(value);
    setFilter({
      ...filter,
      _type: value,
    });
  };

  return (
    <Grid item xs={12} sm={9} sx={12} sx={{ mt: 2 }}>
      <Modal
        keepMounted
        open={openWarehouseTable}
        onClose={handleCloseWarehouseTable}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Paper sx={style}>
          <Grid container>
            <Grid item xs={12} sm={12} sx={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2} sx={12}>
                  <InputField
                    name="_name"
                    value={filter._name}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Name"
                  />
                </Grid>
                <Grid item xs={12} sm={2} sx={12}>
                  <InputField
                    name="_status"
                    value={filter._status}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Status"
                  />
                </Grid>
                <Grid item xs={12} sm={2} sx={12}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Warehouse Type"
                    value={selectedType}
                    onChange={(e) => updateWarehouseType(e.target.value)}
                  >
                    {warehouseTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4} sx={12}>
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        resetFilters();
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        fetchData();
                      }}
                    >
                      Filter
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} sx={12}>
              <SelectingTable
                isOneChoise={isOneChoise}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                title="Warehouses"
                columns={columns}
                rows={warehouseRows}
                setSelected={setSelectedWarehouse}
                selected={selectedWarehouse}
                _key="warehouse_id"
                setOpenTable={setOpenWarehouseTable}
                handleCloseTable={handleCloseWarehouseTable}
              />
            </Grid>

            <Stack spacing={3}>
              <Pagination
                count={totalPages}
                variant="outlined"
                shape="rounded"
                size="small"
                onChange={handleChangepage}
              />
            </Stack>
          </Grid>
        </Paper>
      </Modal>
    </Grid>
  );
}
